"use client";

import { countries, useGeo } from "@/i18n/routing";
import styles from "./GeoSelector.module.css";
import { useTranslations } from "@/i18n/client";

export const GeoStatus = () => {
	const { country, language } = useGeo();
	const realCountry = countries.find((c) => c.country === country);
	const languages = useTranslations("language");
	return (
		<span className={styles.geoStatus}>
			<img
				loading="lazy"
				fetchPriority="auto"
				src={`https://flagcdn.com/w40/${country.toLowerCase()}.png`}
				srcSet={`https://flagcdn.com/w80/${country.toLowerCase()}.png 2x`}
				sizes="(max-width: 767px) 100vw, 10vw"
				style={{
					width: "16px",
					height: "16px",
					objectFit: "cover",
					borderRadius: "50%",
				}}
				alt={realCountry?.name}
			/>
			{languages(language) || realCountry?.name} / ({realCountry?.currency})
		</span>
	);
};
